import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfter() {
  return <section className="w-full py-16 px-4" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-27">
          <h2 className="font-handwriting text-4xl md:text-5xl text-forest mb-4" data-id="element-28">
            Balus Verwandlung
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-29">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-red-50/50 p-8 rounded-2xl border border-red-100" data-id="element-30">
            <h3 className="font-serif text-2xl text-red-800/80 mb-6 font-semibold border-b border-red-100 pb-4" data-id="element-31">
              Vorher
            </h3>
            <ul className="space-y-4" data-id="element-32">
              {['Jeden Morgen Durchfall', 'Ständig beim Tierarzt', 'Erschöpft und lustlos', 'Ich voller Sorgen'].map((item, i) => <li key={i} className="flex items-center gap-3 text-red-900/70 font-serif text-lg" data-id="element-33">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-34" />
                  <span data-id="element-35">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-forest/5 p-8 rounded-2xl border border-forest/20 shadow-sm relative overflow-hidden" data-id="element-36">
            <div className="absolute top-0 right-0 w-32 h-32 bg-forest/5 rounded-bl-full -z-10" data-id="element-37" />
            <h3 className="font-serif text-2xl text-forest mb-6 font-semibold border-b border-forest/10 pb-4" data-id="element-38">
              Heute
            </h3>
            <ul className="space-y-4" data-id="element-39">
              {['Fester, normaler Stuhlgang', 'Keine Tierarztbesuche mehr', 'Voller Energie und Lebensfreude', 'Ich endlich entspannt'].map((item, i) => <li key={i} className="flex items-center gap-3 text-forest font-serif text-lg" data-id="element-40">
                  <CheckCircle2 className="w-6 h-6 text-forest flex-shrink-0" data-id="element-41" />
                  <span data-id="element-42">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}